import React from 'react';

import Header from '../components/Header';
import Footer from '../components/Footer';
import Breadcrumbs from '../components/Breadcrumbs';
import EducationCard from '../components/EducationCard';
import PublicationItem from '../components/PublicationItem';
import scholarData from '../data/scholar.json';

function Education() {
    return (
        <div className="relative flex h-auto min-h-screen w-full flex-col group/design-root overflow-x-hidden">
            <div className="layout-container flex h-full grow flex-col">
                <Header />

                <main className="flex-1 max-w-[1200px] mx-auto px-4 lg:px-10 py-10 w-full bg-slate-900/80 backdrop-blur-sm rounded-xl mt-8 mb-12">
                    <Breadcrumbs />
                    <div className="flex flex-col lg:flex-row gap-12">
                        {/* Main Content Area */}
                        <div className="flex-1 space-y-12">
                            {/* Page Heading */}
                            <div className="flex flex-col gap-3">
                                <h1 className="text-4xl font-black leading-tight tracking-[-0.033em]">Academic Publications &amp; Education</h1>
                                <p className="text-slate-500 dark:text-[#92a4c9] text-lg font-normal max-w-2xl">
                                    I am a Computer Engineer specialized in IoT architectures, R&amp;D project management, and technical leadership in industrial systems.
                                </p>
                            </div>
                            {/* Education Section */}
                            <section>
                                <div className="flex items-center gap-2 mb-6">
                                    <span className="material-symbols-outlined text-primary dark:text-sky-300">school</span>
                                    <h2 className="text-[22px] font-bold tracking-tight">Education</h2>
                                </div>
                                <div className="grid grid-cols-1 gap-4">
                                    <EducationCard
                                        degree="M.Sc. in Computer Engineering"
                                        institution="Marmara University – Istanbul, Türkiye"
                                        year="2022 – 2025"
                                        gpa="3.73 / 4.00"
                                    />
                                    <EducationCard
                                        degree="B.Sc. in Computer Engineering"
                                        institution="Marmara University – Istanbul, Türkiye"
                                        year="2014 – 2018"
                                        gpa="3.02 / 4.00"
                                    />
                                    <EducationCard
                                        degree="Erasmus+ Exchange"
                                        institution="Budapest University of Technology and Economics (BME)"
                                        year="2016 (Electrical Engineering and Informatics)"
                                    />
                                </div>
                            </section>
                            {/* Publications Section */}
                            <section className="space-y-8">
                                <div className="flex items-center gap-2">
                                    <span className="material-symbols-outlined text-primary dark:text-sky-300">menu_book</span>
                                    <h2 className="text-[22px] font-bold tracking-tight">Selected Publications</h2>
                                </div>

                                {/* 2025 */}
                                <div className="space-y-4">
                                    <h3 className="text-sm font-bold uppercase tracking-widest text-primary dark:text-sky-300 border-b border-primary/20 pb-2">2025</h3>
                                    <PublicationItem
                                        venue="ISM 2025"
                                        title="Multiscale RGB–Thermal Fusion for Vulnerable Road User Detection with ScaleFuse"
                                    />
                                    <PublicationItem
                                        venue="WF-PST 2025"
                                        title="A Case Study for Vulnerable Road Users Protection: Systematic Approach for Managing and Scheduling C-ITS Workloads"
                                    />
                                    <PublicationItem
                                        venue="IEEE Open Journal of the Industrial Electronics Society"
                                        title="Artificial Intelligence for Wireless Communications: The InSecTT Perspective"
                                    />
                                </div>

                                {/* 2024 */}
                                <div className="space-y-4">
                                    <h3 className="text-sm font-bold uppercase tracking-widest text-primary dark:text-sky-300 border-b border-primary/20 pb-2">2024</h3>
                                    <PublicationItem
                                        venue="IEEE Access"
                                        title="LSTM-Based Jamming Detection and Forecasting in Wi-Fi-Based IoT Systems"
                                    />
                                    <PublicationItem
                                        venue="Book Chapter (Springer)"
                                        title="Big Data Streaming and Data Analytics Infrastructure for Efficient AI-Based Processing"
                                    />
                                    <PublicationItem
                                        venue="Book Chapter (Springer Nature)"
                                        title="Security of Wireless IoT in Smart Manufacturing: Vulnerabilities and Countermeasures"
                                    />
                                </div>

                                {/* 2023 */}
                                <div className="space-y-4">
                                    <h3 className="text-sm font-bold uppercase tracking-widest text-primary dark:text-sky-300 border-b border-primary/20 pb-2">2023</h3>
                                    <PublicationItem
                                        venue="ICPMV 2023"
                                        title="Performance Evaluation of Recent Object Detection Models for Traffic Safety Applications on Edge"
                                    />
                                </div>
                            </section>
                        </div>
                        {/* Sidebar Area */}
                        <aside className="lg:w-80 space-y-6">
                            {/* Research Metrics */}
                            <div className="sticky top-10 space-y-6">
                                <div className="p-6 rounded-xl border border-slate-200 dark:border-[#324467] bg-white dark:bg-[#1a2333] shadow-sm">
                                    <h3 className="text-sm font-bold uppercase text-slate-500 dark:text-[#92a4c9] mb-4">Impact Metrics</h3>
                                    <div className="space-y-4">
                                        <div className="flex justify-between items-end border-b border-slate-100 dark:border-slate-800 pb-2">
                                            <p className="text-sm font-medium">Total Citations</p>
                                            <p className="text-3xl font-black text-primary dark:text-sky-300">{scholarData.citations}</p>
                                        </div>
                                        <div className="flex justify-between items-end border-b border-slate-100 dark:border-slate-800 pb-2">
                                            <p className="text-sm font-medium">h-index</p>
                                            <p className="text-3xl font-black">{scholarData.hIndex}</p>
                                        </div>
                                        <div className="flex justify-between items-end">
                                            <p className="text-sm font-medium">i10-index</p>
                                            <p className="text-3xl font-black text-slate-400">{scholarData.i10Index}</p>
                                        </div>
                                    </div>
                                    <div className="mt-6 flex flex-col items-center gap-2">
                                        <a className="flex items-center justify-center gap-2 text-xs font-bold text-slate-500 hover:text-primary transition-colors" href="https://scholar.google.com/citations?user=dNT6guoAAAAJ&hl=en&oi=ao" target="_blank" rel="noopener noreferrer">
                                            <span className="material-symbols-outlined text-sm">bar_chart</span>
                                            Google Scholar Profile
                                        </a>
                                        {scholarData.lastUpdated && (
                                            <span className="text-[10px] text-slate-400 dark:text-slate-500">
                                                Last updated: {new Date(scholarData.lastUpdated).toLocaleDateString()}
                                            </span>
                                        )}
                                    </div>
                                </div>

                            </div>
                        </aside>
                    </div>
                </main>
                {/* Footer / Contact & Network */}
                <Footer />
            </div>
        </div>
    );
}

export default Education;

